import sv from "./sv.json"
import en from "./en.json"

export default{
    sv,
    en
}